import { createSelector } from '@reduxjs/toolkit';

export const selectSoBoPages = createSelector(
  ({ soboPages }) => soboPages,
  (state) => state,
);
